import { __, sprintf } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';

const AdditionalMessage = ( { quoteData } ) => {
    if (
        ! quoteData?.customer_info?.customer_additional_msg &&
        ! quoteData?.store_info?.vendor_additional_msg
    ) {
        return null;
    }

    return (
        <div className="bg-white rounded-lg shadow">
            <div className="p-5 border-b border-gray-200 space-y-4">
                <h2 className="text-lg font-semibold text-[#25252D]">
                    { __( 'Additional Message', 'dokan' ) }
                </h2>
            </div>
            <div className="">
                { quoteData?.customer_info?.customer_additional_msg && (
                    <div className="p-5 border-b border-gray-200 last:border-0 space-y-2.5">
                        <div className="text-[#575757] text-base leading-snug">
                            { decodeEntities(
                                quoteData.customer_info.customer_additional_msg
                            ) }
                        </div>
                        <div className="text-xs text-[#828282]">
                            { sprintf(
                                /* translators: %1$s: Customer name */
                                __( 'Customer: %1$s', 'dokan' ),
                                quoteData?.customer_info?.name_field
                            ) }
                        </div>
                    </div>
                ) }

                { quoteData?.store_info?.vendor_additional_msg && (
                    <div className="p-5 border-b border-gray-200 last:border-0 space-y-2.5">
                        <div className="text-[#575757] text-base leading-snug">
                            { decodeEntities(
                                quoteData.store_info.vendor_additional_msg
                            ) }
                        </div>
                        <div className="text-xs text-[#828282]">
                            { sprintf(
                                /* translators: %1$s: Store name */
                                __( 'Store: %1$s', 'dokan' ),
                                quoteData.store_info?.store_name
                            ) }
                        </div>
                    </div>
                ) }
            </div>
        </div>
    );
};

export default AdditionalMessage;
